GP.GPMod('manage_notification',function(self){
    var vent   = null;
    var common = null;
    var _log   = null;
    var cur_profile;

    var data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            common = self.app.Util;
            _log   = self.app.Util.log;

        },
        timout: 2000
    };


    var gui = {
        init: function() {
            this.$modal_submit_btn   = $('#bs-notify-me-modal-submit');
            this.$notify_me_btn      = $('.option-notify');
            this.$remove_alert_btn   = $('.alert_type_remove');
        },
    };


    var handlers = {
        notify_me: function(json) {

            var checked_opts = $('.notify-me .alert_opt:checked');
            if (json.status) {
                cur_profile.find('input[name="types[]"]').remove();
                if (checked_opts.length) {
                    $.each(checked_opts, function(i, obj) {
                        cur_profile.prepend('<input type="hidden" name="types[]" value="'+$(obj).val()+'">');
                    });
                }
                $('.form-checkboxes').hide();
                $('#alert_result').text(alert_msg_saved).show();
                setTimeout(function() {
                    vent.trigger('Modal:close');
                }, 1200);
            } else {
                $('.alert_form, .alert_info').hide();
                $('#alert_result').text(alert_msg_error).show();
                setTimeout(function() {
                    vent.trigger('Modal:close');
                }, 1500);
            }
        },

    };

    var events = {
        init: function() {
            vent.on('init_js:user:edit_account', events.setup_binds);
            vent.on(self.moduleName + ':setup_binds', events.setup_binds);
        },
        setup_binds: function() {
            // setup jquery selectors
            gui.init();

            gui.$notify_me_btn.on('click', events.notify_me);
            gui.$modal_submit_btn.on('click', function(e) {
                $("#notify-modal form.notify-me").submit();
            });
            gui.$remove_alert_btn.on('click', events.remove_alert_types);

            $('.img_cont').mouseenter(function() { $(this).find('.notify_overlay').show(); });
            $('.img_cont').mouseleave(function() { $(this).find('.notify_overlay').hide(); });

        },
        notify_me: function(e) {
            e.preventDefault();

            var obj = {
                modal_options: {
                    backdrop:      true,
                    keyboard:      true
                },
                modal_div: $("#notify-modal"),
            };

            cur_profile = $(e.target).closest('.profile_cont');
            var alert_form = $('.notify-me');
            var alert_duid = cur_profile.data('duid');
            alert_form.find('input[name="alert_duid"]').val(alert_duid);

            var types = cur_profile.find('input[name="types[]"]');

            if (types.length) {
                $('.alert_opt').removeAttr('checked');

                var cur_chk_box;
                $.each(types, function(i, type) {
                    cur_chk_box = alert_form.find('input[value="'+$(type).val()+'"]');
                    cur_chk_box.prop('checked', true);
                });
            }

            $('#alert_pic').css('background-image',  'url("' + cur_profile.find('.img_cont img').attr('src') + '")');
            $('#alert_username').text(cur_profile.data('username'));
            $('#alert_age').text(cur_profile.data('age'));
            $('#alert_location').text(cur_profile.data('location'));
            $('.alert_info').hide();
            $('.form-checkboxes').show();
            alert_form.show();

            $("#notify-modal form.notify-me").on('submit', events.notify_me_submit_handler);

            vent.trigger('Modal:open:static', obj);
        },
        notify_me_submit_handler: function(e) {
            e.preventDefault();
            var checked_opts = $('.notify-me .alert_opt:checked');
            var data = $(e.target).serialize();

            $.post('/members/network/mod_alerts', data, function(data) {
                if (data.status) {
                    cur_profile.find('input[name="types[]"]').remove();
                    if (checked_opts.length) {
                        $.each(checked_opts, function(i, obj) {
                            cur_profile.prepend('<input type="hidden" name="types[]" value="'+$(obj).val()+'">');
                        });
                        $('#alert_result').text(alert_msg_saved);
                    } else {
                        cur_profile.remove();
                        $('#alert_result').text(alert_msg_remove_user);
                    }
                    $('.form-checkboxes').hide();
                    $('.alert_form, .alert_info').hide();
                    $('#alert_result').show();
                    setTimeout(function() {
                        vent.trigger('Modal:close');
                    }, 1200);
                } else {
                    $('.alert_form, .alert_info').hide();
                    $('#alert_result').text(alert_msg_error).show();
                    setTimeout(function() {
                        vent.trigger('Modal:close');
                    }, 1500);
                }
            });
        },
        remove_alert_types: function(e) {
            e.preventDefault();
            var remove_btn = this;
            var type = $(this).attr('id').split('-').pop();
            var message = alert_msg_remove_all.replace('%d', alert_type_totals[type]);
            var grids = $('.grid_thumb_wrap');

            if (confirm(message)) {
                $.post('/members/network/del_alerts', { types: [type] }, function(data) {
                    if (data.status) {
                        $.each(grids, function(i, obj) {
                            if ($(obj).hasClass('LOGGED_IN') && $(obj).hasClass('VIDEOCHAT')) {
                                $(obj).removeClass(type);
                                $(".grid_thumb_wrap input[value='"+type+"']").remove();
                            } else if ($(obj).hasClass(type)) {
                                $(obj).hide();
                            }
                        });
                        $(remove_btn).hide();
                    } else {
                        alert(alert_msg_error);
                    }
                });
            }
        }
    };

    this.addInitializer(function(){
        data.init();
        events.init();
    });
});
